import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';

import {Container, Wrapper, FooditLogo, UrlLink, Name, TCs, Right, PoweredBy} from './Footer.style';
import {FOODITWEBSITE} from '../../constants/constant';

export const Footer = props => {
  return (
    <Container revert={props.revert}>
      <Wrapper revert={props.revert}>
        <Name>&copy; {props.name}</Name>
        <Right>
          <Link
            to={props.navUrls.termsUrl}
            data-rw="footer--terms-link"
            target="_blank"
          >
            <TCs revert={props.revert}>
              <FormattedMessage id="footer.termsAndConditions" />
            </TCs>
          </Link>
          <PoweredBy>
            <span>
              <FormattedMessage id="footer.poweredBy" />
            </span>
            <UrlLink
              href={FOODITWEBSITE.URL}
              target="_blank"
            >
              <FooditLogo
                src="https://cdn-dot-foodit-prod.appspot.com/assets/foodit--logo.svg"
                alt="FOODit"
              />
            </UrlLink>
          </PoweredBy>
        </Right>
      </Wrapper>
    </Container>
  );
};

Footer.propTypes = {
  name: PropTypes.string,
  revert: PropTypes.bool,
  navUrls: PropTypes.object
};



// WEBPACK FOOTER //
// ./containers/LightHomePage/Footer.js